
<template>
  <div>
    <van-nav-bar
      class="navbar"
      :fixed="true"
      title="调查问卷"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="content">
      <!-- <search @select="onSelect" /> -->
    
 

      <div class="" v-if="useMessage.客户姓名">

        <van-form @submit="onSubmit" name="userinfo" ref="userinfo">
          <van-cell  title="客户姓名" :value="useMessage.客户姓名"/>
          <van-cell  title="客户电话" :value="useMessage.客户电话|maskTel"/>
           <!-- <van-field
                v-model="useMessage.客户姓名"
                 label="客户姓名"
                readonly
               
              /> -->

               <!-- <van-field
                v-model="useMessage.客户电话"
                 label="客户电话"
                readonly
               
              /> -->
          <van-cell-group v-for="(c, i) in questionnaire" :key="i">
            <template v-if="c.type == 'date'">
              <van-field
                v-model="append[c.title].value"
                readonly
                required
                clickable
                :label="c.title"
                :placeholder="c.title"
                :rules="[rule_required]"
                @click="onShowDate(i)"
              />
            </template>
            <template v-else>
              <van-field
                v-if="c.type == 'select'"
                v-model="append[c.title].value"
                readonly
                required
                clickable
                :label="c.title"
                :placeholder="c.title"
                :rules="[rule_required]"
                @click="ShowPopub(i)"
              />

              <van-field
                v-else
                v-model="append[c.title].value"
                type="text"
                :label="c.title"
                :placeholder="c.title"
              />
            </template>
          </van-cell-group>

          <div class="tools">
            <van-row gutter="30">
              <van-col span="12">
                <van-button round block @click.prevent="useMessage={}"
                  >取消</van-button
                >
              </van-col>
              <van-col span="12">
                <van-button round block type="info" native-type="submit"
                  >提交</van-button
                >
              </van-col>
            </van-row>
          </div>
        </van-form>
      </div>
      <clist v-else  @click="onUserSelect" :req="{问卷日期:{'$exists':false},跟办顾问:{'$exists':true}}" :title="'调查问卷'"></clist>
    </div>

    <van-popup v-model="showPopup" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="popupList"
        @cancel="showPopup = false"
        @confirm="onPopupConfirm"
      />
    </van-popup>
    <van-calendar v-model="dateshow" @confirm="onConfirm" />
  </div>
</template>
<script>
// import search from "@/views/components/selectCustomer";
// import appendinfo from "./appendinfo";


import clist from "@/views/crm/customer/clist/index.vue";

import { parseTime } from "@/utils/date";
export default {
  name: "commodityList",
  components: { clist},
  props: {
    // commodity: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   },
    // },
  },

  data() {
    return {
      dateshow: false,
      showPopup: false,
      popubIndex: -1,
      popupList: [],
      projectname: localStorage.getItem("projectname"),

      useMessage: {},
      questionnaire: [],
      append: {},
      rule_required: {
        trigger: "onBlur",
        required: true,
        message: "请补充信息",
      },
    };
  },

  watch: {
    // commodity(newV,oldV) {
    //   this.onRefresh();
    // }
  },
  created() {
    this.getQuestionnaire();
  },

  methods: {
    onShowDate(index) {
      this.dateshow = true;
      this.popubIndex = index;
    },

    // formatDate(date) {
    //   return `${date.getMonth() + 1}/${date.getDate()}`;
    // },
    onConfirm(date) {
      var title = this.questionnaire[this.popubIndex].title;

      var v = parseTime(date, "{y}-{m}-{d}");
      console.log(title, v, this.append[title]);
      this.append[title].value = v;
      this.dateshow = false;

      // this.append['到访时间'].value = parseTime(date,'{y}-{m}-{d}')
    },

    onUserSelect(user) {
      this.useMessage = user;
      if (this.useMessage.调查问卷 == undefined) {
        this.useMessage.调查问卷 = [];
      }
      this.fullQ();
    },
    fullQ() {
      console.log(this.useMessage.调查问卷);

      for (var i in this.questionnaire) {
        let q = this.questionnaire[i];
        let title = q.title;
        let value = undefined;
        for (var j in this.useMessage.调查问卷) {
          let u = this.useMessage.调查问卷[j];
          if (u.title == title) {
            value = u.value;
          }
          //this.$set(this.append, q.title, { title: q.title,value: this.useMessage.appendinfo[i].value});

          //this.append[q.title].value = this.useMessage.appendinfo[i].value;
        }

        this.$set(this.append, q.title, { title: title, value: value });
        console.log(this.append);
      }

      for (var i in this.useMessage.调查问卷) {
        let q = this.useMessage.调查问卷[i];
        this.$set(this.append, q.title, {
          title: q.title,
          value: this.useMessage.调查问卷[i].value,
        });

        //this.append[q.title].value = this.useMessage.appendinfo[i].value;
      }
    },
    getQuestionnaire() {
      let req = {
        table_name: "sys_questionnaire",
        req: { 所属项目: "新基业当代阅ΜΟΜΛ" },
        sort: "order",
      };
      this.$request.dbreq(req).then((res) => {
        this.$set(this, "questionnaire", res.data.items);
        this.questionnaire = res.data.items;

        // appendinfo
      });
    },
    fullReqs() {
      for (var i in this.questionnaire) {
        let title = this.questionnaire[i].title;
        let flag = true;
        for (var j in this.useMessage.调查问卷) {
          if (this.useMessage.调查问卷[j].title == title) {
            flag = false;
          }
        }
        if (flag) this.useMessage.调查问卷.push({ title: title });
      }

      for (var i in this.useMessage.调查问卷) {
        let title = this.useMessage.调查问卷[i].title;
        this.useMessage.调查问卷[i].value = this.append[title].value;
      }

      this.useMessage["问卷日期"]=Date.parse(new Date()).toString()
    },

    //提交信息
    onSubmit() {
      //console.log(this.useMessage);
      this.fullReqs();
      
      //console.log(this.useMessage);
      this.$request.customerSave(this.useMessage).then((res) => {
        if (res.code == 0) {
          this.$toast({
            message: "保存成功",
          });
          //this.$router.back();
          this.useMessage={}
        } else {
          this.$toast({
            message: res.msg,
          });
        }
      });

      // this.restUseMessge();
    },
    ShowPopub(index) {
      this.showPopup = true;
      this.popubIndex = index;
      this.popupList = this.questionnaire[index].list;
    },
    onPopupConfirm(value) {
      var title = this.questionnaire[this.popubIndex].title;
      this.append[title] = { title, value };
      this.showPopup = false;
    },
  },
};
</script>
<style scoped lang="less">
.navbar {
}
.top {
  height: 1px;
}
.content {
  overflow: scroll;
  margin-top: 50px;
  height: calc(100vh - 140px);
}
.tools {
  padding: 0 30px;
  margin-top: 20px;
}
#commodityList {
  margin-top: 10px;
  padding: 0 10px;

  .commodityBox {
    flex-wrap: wrap;
    font-size: 14px;

    .commodityContainer {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px !important;
      border-radius: 20px;

      // box-shadow: #666 5px 5px 5px;
      .textBox {
        margin: 5px 0px 5px 0px;

        .colon {
          display: inline-block;
          margin: 0 4px;
          color: black;
        }

        .block {
          display: inline-block;
          width: 30px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background-color: #ee0a24;
        }

        .batch {
          color: green;
        }

        .batch p {
          margin: 3px;
        }
      }
    }
  }
}
</style>